module.exports = __webpack_public_path__ + "img/ico_badge12.d564a6a7.svg";